import React, { useMemo } from 'react';

import {
	MeetingListTableTr,
	MeetingListTableTh,
	DefaultTable,
	MeetingAction,
} from '@components';

import {
	MeetingListItem,
} from '@api';

import './MeetingListTable.scss';
import '../../../components/shared/controls/BusyArea.scss';

interface MeetingListTableProps {
	meetings: MeetingListItem[],
	allowClickInProcess: boolean,
	paginationView?: JSX.Element,
	visitedMeetingIds: string[],
	isBusy: boolean;
	onMeetingAction: (meeting: MeetingListItem, action: MeetingAction) => void,
}

function MeetingListTable(props: MeetingListTableProps): JSX.Element {
	const { 
		meetings,
		allowClickInProcess,
		paginationView,
		onMeetingAction,
		visitedMeetingIds,
		isBusy,
	} = props;
	

	const tbodyView = useMemo((): JSX.Element => {
		return (
			<React.Fragment>
				{meetings.map((meeting) =>
					<MeetingListTableTr
						isHighlighted={false}
						meeting={meeting}
						key={meeting.id}
						visited={visitedMeetingIds.includes(meeting.id)}
						allowClickInProcess={allowClickInProcess}
						onMeetingAction={onMeetingAction}
					/>
				)}
			</React.Fragment>
		);
	}, [meetings, allowClickInProcess, onMeetingAction,
		visitedMeetingIds]);

	return (<div>{isBusy && <div className='busy-area'>
					<div className='busy-area-bar'></div>
				</div>
		}
		<DefaultTable
			className="meeting-list-table"
			thead={<MeetingListTableTh />}
			tbody={tbodyView}
		/>
		{paginationView}
		</div>
	);
}

export {MeetingListTable};